<template>
    <div>
        <div class="card-header">
            <h3>{{ $t("lang.label_template") }}</h3>
        </div>
        <div class="card-body" style="min-height: 200px">
            <div class="row">
                <form @submit.prevent="SaveForm()" style="width: 100%">
                    <div class="row">
                        <div class="form-group col-md-12">
                            <div class="input-group">
                                <select class="form-control" v-model="reg.id" v-if="!loading">
                                    <option value="1">Template 1</option>
                                    <option value="2">Template 2</option>
                                </select>
                                <div v-else>Loading...</div>
                            </div>
                        </div>
                        <div class="form-group col-md-12">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button
                                        type="submit"
                                        class="btn btn-info"
                                        :disabled="btnSave"
                                    >
                                        <i class="fas fa-save fa-ms"></i>
                                        {{ $t("lang.label_save") }}
                                    </button>
                                    <a
                                        class="btn btn-add-group"
                                        @click="closeModal"
                                        style="margin-left: 10px; color: inherit;"
                                    >
                                        {{ $t("lang.label_cancel") }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "templates",
    data () {
        return {
            btnSave: false,
            dat: [],
            reg: {
                id: 1,
                name: null,
                slug: null,
                user_id: window.master_client,
                org_id: window.localuserdata,
            },
            templateID_old: 1,
            loading: true,
        }
    },
    created () {
        this.getTemplate();
    },
    methods: {
        SaveForm() {
            let t = this;
            if(t.templateID_old != t.reg.id){
                t.btnSave = true;
                t.isLoading = true;
                t.loading = true;
                window.master
                .post("/restaurants/setTemplate", t.reg)
                .then((response) => {
                    console.log(response.data);
                    let r = response.data;
                    t.btnSave = false;
                    t.loading = false;
                    t.closeModal();
                })
                .catch((error) => {
                    t.btnSave = false;
                    t.loading = false;
                    t.closeModal();
                    console.log(error);
                });
            }else{
                t.closeModal();
            }
        },
        getTemplate() {
            let t = this;
            t.loading = true;
            window.master
                .post("/restaurants/getTemplate", t.reg)
                .then((response) => {
                    let r = response.data;
                    t.reg.id = (r.id) ? r.id : 1;
                    t.templateID_old = (r.id) ? r.id : 1;
                    t.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                    t.loading = false;
                });
        },
        closeModal() {
            this.$modal.hide("modal-setting");
        },
    },
}
</script>
<style lang="scss" scoped>
.btn-add-group {
    background-color: #fff;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #666;
    width: 100% !important;
}
</style>
